module.exports = __webpack_public_path__ + "static/media/QR.1f6b782c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/configurator/payment/QR.jpg
// module id = 974
// module chunks = 0